module.exports = __webpack_public_path__ + "static/media/Topo-Abs-BG.052b93cf.svg";